import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserModel } from '../model/user.model';
import { UserVO } from '../model/vo/user.vo';
import { RouteNavigationService } from '@services/route-navigation.service';
import { QueryUtils } from '@shared/util/query.utils';
import { StringUtils } from '@shared/util/string-utils';
import { Log } from '@shared/debug/log';
import { UserSessionService } from '../service/user-session.service';

export const authorizedGuard = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const userModel = inject(UserModel);
  const userSessionService = inject(UserSessionService);
  const routeNavigationService = inject(RouteNavigationService);

  const redirectFromLogin = async () => {
    if (userModel.isUserLoggedIn && state.url.startsWith("/profile/login")) {
      await routeNavigationService.toOpenProject();
    }
  };

  const handleQueryUrls = async (isLoggedIn: boolean) => {
    const isEshop = QueryUtils.getParameterByName('isEshop');
    const isAssistantImportLink = QueryUtils.isAssistantImportLink();
    const isTemporaryLink = QueryUtils.isTemporaryLinkUrl();

    if (isLoggedIn || (isEshop === 'true' && userModel.user)
      || (isAssistantImportLink && userModel.user) || (isTemporaryLink && userModel.user)) {
      const isConstruction = userModel.user.isProduction()
        || StringUtils.parseBoolean(QueryUtils.getParameterByName('construction'));
      if (QueryUtils.hasConfiguratorParams() || isConstruction) {
        await routeNavigationService.toConfigurator();
        return false;
      } else {
        return true;
      }
    } else {
      await routeNavigationService.toLogin();
      return false;
    }
  };

  await redirectFromLogin();

  if (!userModel.user || userModel.user === UserVO.ANONYMOUS) {
    try {
      await userSessionService.reLogin();
    } catch (error) {
      Log.error('Could not re-login user: ', error);
      return false;
    }

    await redirectFromLogin();

    if (QueryUtils.getParameterByName('function') === 'createproject' && !userModel.isUserLoggedIn) {
      await routeNavigationService.toConfigurator();
      return false;
    }
    return await handleQueryUrls(userModel.isUserLoggedIn);
  }

  return true;
};
